import { AUTH_MESSAGE_CODES } from "../auth/auth.const";

import { CUSTOMER_MANAGEMENT_ACTION_TYPE } from "./customer-management.action";

const CONTEXT_PREFIX = "[Customer Management]";
export const CUSTOMER_MANAGEMENT_MESSAGE_CONTEXT = {
	checkEmailAvailability: CUSTOMER_MANAGEMENT_ACTION_TYPE.checkEmailAvailability,
	customer: `${CONTEXT_PREFIX} Customer`,
	newsletter: `${CONTEXT_PREFIX} Newsletter`,
	termsAndConditions: `${CONTEXT_PREFIX} Terms And Conditions`,
	privacyPolicy: `${CONTEXT_PREFIX} Privacy Policy`,
	entityLegalNotice: `${CONTEXT_PREFIX} Entity Legal Notice`,
	confirmProfile: `${CONTEXT_PREFIX} Confirm Profile`,
	verifyToken: CUSTOMER_MANAGEMENT_ACTION_TYPE.verifyToken,
};

export const CUSTOMER_MANAGEMENT_MESSAGE_CODES = {
	updateSuccess: "M_CUSTOMER_UPDATE_SUCCESS",
	updateFail: "E_CUSTOMER_UPDATE_FAIL",
	invalidJurisdiction: "E_CURRENTCUSTOMER_INVALIDJURISDICTION",
};

export const CUSTOMER_MANAGEMENT_ROUTE = {
	root: "account-settings",
	myProfile: "account-settings.my-profile",
	changePassword: "account-settings.change-password",
	passwordSettings: "account-settings.password-settings",
	subscriptions: "account-settings.subscriptions",
	securityOptions: "account-settings.security-options",
	documents: "account-settings.documents",
	twoFactorAuth: "account-settings.two-factor-auth",
	closeAccount: "account-settings.close-account",
};

export const HIDE_GROUP_CONSENT_COUNTRY_OF_REGISTRATION = "hideGroupConsentCountryOfReg";
export const COUNTRY_OF_REGISTRATION = "countryOfRegistration";

export const TERMS_AND_CONDITIONS_AUTH_CODES = [
	AUTH_MESSAGE_CODES.login.termsAndConditionsNotAccepted,
	AUTH_MESSAGE_CODES.login.latestTermsAndConditionsNotAccepted,
];

export const PRIVACY_POLICY_AUTH_CODES = [AUTH_MESSAGE_CODES.login.latestPrivacyPolicyNotAccepted];

export const MASKED_VALUE = "***";
export const REMOVE_CONTENT_IN_BRACKETS_REGEX = / *\([^)]*\) */g;
